import i18n from './spa/i18n';

export function generateUrl(path: string, subdomain: string = null) {
    let protocol = match(process.env.MIX_APP_ENV, {
        'local' : 'http',
        'production' : 'https',
    });

    let domain = match(process.env.MIX_APP_ENV, {
        'local' : 'fasunok.loc',
        'production' : 'fasunok.com',
    });

    if (subdomain) {
        domain = `${subdomain}.${domain}`;
    }

    return `${protocol}://${domain}/${path}`;
}

export function match<T, R>(value: T, patterns: { [key: string]: R | ((v: T) => R) }): R {
    if (value in patterns) {
        const result = patterns[value];
        return typeof result === 'function' ? (result as Function)(value) : result;
    }

    throw new Error(`No match found for value: ${value}`);
}

export function getMarketplaceNotFoundEntity(error: any): 'category' | 'attribute' | null {
    if (error.response.status !== 404) {
        return null;
    }

    const message = error.response.data.message;

    if (message.includes('MarketplaceAttribute')) {
        return 'attribute';
    }

    if (message.includes('MarketplaceCategory')) {
        return 'category';
    }

    return null;
}

export function getMessageFromMarketPlaceError(error: any): string | null {
    if (error.response.status !== 404) return null;

    const message = error.response.data.message;

    if (message.includes('MarketplaceAttribute')) return i18n.global.t('alerts.marketplace_attribute_not_found');
    if (message.includes('MarketplaceCategory')) return i18n.global.t('alerts.marketplace_category_not_found');
    
    return null;
}

/**
 * Cities with the same name exist in different regions, so the district and the region
 * are a part of the name everywhere the city is shown to the user.
 */
export function formatDeliveryCityName(city: { name?: string, district?: string, region?: string } | null): string {
    if (!city?.name) {
        return '';
    }

    return [
        city.name,
        city.district ? `${city.district} ${i18n.global.t('labels.district_short')}` : null,
        city.region ? `${city.region} ${i18n.global.t('labels.region_short')}` : null,
    ].filter(Boolean).join(', ');
}

export function chunk<T>(array: T[], chunkSize: number): T[][] {
    if (chunkSize <= 0) {
        throw new Error("Chunk size must be greater than 0");
    }

    const chunks: T[][] = [];

    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }

    return chunks;
}
